module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-cal",
    class: [{
        'd-cal--multi': _vm.isMultiCalendar
      },
      {
        'd-cal--am-pm': _vm.isLocaleEn
      },
      {
        'd-cal--loading': _vm.isLoadingEvents
      },
      {
        'd-cal--is-list-view': _vm.isShowAsList
      },
      {
        'd-cal--highlight-events': _vm.isCopyCalendarModalOpen
      }
    ],
    attrs: {
      "id": 'calendar_dom_id_' + _vm.calendarDOMUuid
    }
  }, [(_vm.isLoadingEvents) ? _c('div', {
    staticClass: "d-cal__events-loading"
  }, [_c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isShowAsList) ? _c('DCalendarList', {
    attrs: {
      "calendarName": _vm.calendarName,
      "events": _vm.eventsWithMetaData,
      "date": _vm.date,
      "isShowWeekends": _vm.isShowWeekends,
      "firstDayOfWeek": _vm.firstDayOfWeek,
      "isCalendarInPrintMode": _vm.isCalendarInPrintMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEditable && _vm.calendarId && !_vm.isLocked && !_vm.isMoveOnly) ? _c('DCalendarSubjects', {
    attrs: {
      "calendar-id": _vm.calendarId,
      "dragActiveDate": _vm.dragActiveDate,
      "school": _vm.school,
      "locale": _vm.locale,
      "deleteSubject": _vm.deleteSubject
    },
    on: {
      "movedXY": _vm.setMovedXY,
      "setDragLesson": _vm.setTheExternalEvent,
      "setIsDraggingExternalEvent": _vm.setIsDraggingExternalEvent,
      "doMouseUp": _vm.subjectsMouseUp,
      "onMouseEnter": _vm.onMouseEnterSubjects,
      "onMouseLeave": _vm.onMouseLeaveSubjects,
      "setActiveSubjectBCR": _vm.setTheExternalEventBCR
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isShowAsList) ? _c('div', {
    staticClass: "d-cal__week"
  }, [(!_vm.isHideHeader) ? _c('div', {
    staticClass: "d-cal__header"
  }, [(_vm.isMultiCalendar) ? _c('div', {
    staticClass: "d-cal__week__header__name",
    class: {
      'd-cal__week__header__name--no-sidebar': !_vm.showSidebar
    }
  }, [_vm._v(_vm._s(_vm.calendarName) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "d-cal__week__header"
  }, [(_vm.showSidebar) ? _c('li', {
    staticClass: "d-cal__week__header__day--weeknumber"
  }, [(!_vm.isHideDates) ? [_vm._v(_vm._s((_vm.i18n[_vm.locale] || _vm.i18n['en']).week) + " " + _vm._s(_vm.theWeekNumber))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return _c('li', {
      staticClass: "d-cal__week__header__day",
      class: {
        'd-cal__week__header__day--today': day.isToday
      }
    }, [_vm._v("\n          " + _vm._s(_vm.isHideDates ? day.dayName : day.date) + "\n          "), (day.isToday && !_vm.isCalendarInPrintMode) ? _c('span', [_vm._v(_vm._s(_vm.$t('repitition.today')))]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-cal__week__timed"
  }, [(_vm.showSidebar) ? _c('ul', {
    staticClass: "d-cal__week__timed__sidebar"
  }, _vm._l((_vm.hoursInLocale), function(n, key) {
    return _c('li', {
      staticClass: "time"
    }, [(key !== 0) ? _c('span', [_vm._v(_vm._s(n))]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-cal__week__timed__container"
  }, [_c('ul', {
    staticClass: "d-cal__week__timed__background"
  }, [_c('ul', {
    staticClass: "days-container"
  }, _vm._l((_vm.days), function(day) {
    return _c('li', {
      staticClass: "days-container__day"
    }, [(_vm.isEditable) ? _c('DCalendarDayDraggable', {
      attrs: {
        "calendar": _vm.calendar,
        "isLocked": _vm.isLocked,
        "events": _vm.eventsWithMetaData,
        "calendarId": _vm.calendarId,
        "calStartTime": _vm.calStartTime,
        "calEndTime": _vm.calEndTime,
        "slotHeight": _vm.slotHeight,
        "isEventsClickable": _vm.isEventsClickable,
        "date": day.day,
        "dragLesson": _vm.theDragLesson,
        "dragEventY": _vm.dragEventY,
        "dragActiveDate": _vm.dragActiveDate,
        "dragActiveDates": _vm.dragActiveDates,
        "dragEventEnd": _vm.dragEventEnd,
        "dragEventStart": _vm.dragEventStart,
        "dragEventHeight": _vm.dragEventHeight,
        "isResizingEvent": _vm.isResizingEvent,
        "isSideResizingEvent": _vm.isSideResizingEvent,
        "isDraggingEvent": _vm.isDraggingEvent,
        "isDraggingExternalEvent": _vm.isDraggingExternalEvent,
        "theExternalEvent": _vm.theExternalEvent,
        "isCopyCalendarModalOpen": _vm.isCopyCalendarModalOpen,
        "showGrid": _vm.showGrid,
        "gridSlots": _vm.gridSlots,
        "hoveredSlotIndex": _vm.hoveredSlotIndex,
        "isMoveOnly": _vm.isMoveOnly
      },
      on: {
        "moveEvent": function($event) {
          return _vm.$emit('onEventMove', $event)
        },
        "setDragEventEnd": _vm.setDragEventEnd,
        "setDragEventStart": _vm.setDragEventStart,
        "setDragLesson": _vm.setTheDragLesson,
        "setDragEventY": _vm.setDragEventY,
        "setDragEventHeight": _vm.setDragEventHeight,
        "setDragActiveDate": _vm.setDragActiveDate,
        "setIsResizingEvent": _vm.setIsResizingEvent,
        "setIsSideResizingEvent": _vm.setIsSideResizingEvent,
        "setIsDraggingEvent": _vm.setIsDraggingEvent,
        "onEventClick": _vm.onEventClick,
        "onMouseUp": _vm.onMouseUpFromDragging,
        "startSelectionDeleteDrag": _vm.startSelectionDeleteDrag,
        "moveSelectionDeleteDrag": _vm.moveSelectionDeleteDrag,
        "endSelectionDeleteDrag": _vm.endSelectionDeleteDrag,
        "setIsDraggingExternalEvent": _vm.setIsDraggingExternalEvent,
        "setTheDeleteSubjectCursorPlacement": _vm.setTheDeleteSubjectCursorPlacement,
        "setHoveredSlotIndex": _vm.setHoveredSlotIndex
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('DCalendarDay', {
      attrs: {
        "events": _vm.eventsWithMetaData,
        "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
        "isCalNoBgColors": _vm.isCalNoBgColors,
        "localeOverride": _vm.locale,
        "calendarId": _vm.calendarId,
        "isMobile": _vm.isMobile,
        "calStartTime": _vm.calStartTime,
        "calEndTime": _vm.calEndTime,
        "slotHeight": _vm.slotHeight,
        "isEventsClickable": _vm.isEventsClickable,
        "eventFontSize": _vm.eventFontSize,
        "date": day.day,
        "isHideCalendars": _vm.isHideCalendars,
        "isHideDates": _vm.isHideDates
      },
      on: {
        "onPresenceClick": _vm.onPresenceClick,
        "onEventClick": _vm.onEventClick
      }
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _vm._l((_vm.hoursInLocale.length * 2), function(n) {
    return _c('li', {
      key: n,
      staticClass: "time-slot"
    })
  })], 2), _vm._v(" "), (_vm.showGrid && _vm.gridSlots.length > 0) ? _c('div', {
    staticClass: "d-cal__grid-overlay"
  }, _vm._l((_vm.gridSlots), function(slot) {
    return _c('div', {
      key: 'grid-' + slot.index,
      staticClass: "d-cal__grid-slot",
      class: {
        'd-cal__grid-slot--hovered': _vm.hoveredSlotIndex === slot.index
      },
      style: ({
        top: slot.topPx + 'px',
        height: slot.heightPx + 'px'
      })
    }, [_c('span', {
      staticClass: "d-cal__grid-slot__label"
    }, [_vm._v(_vm._s(slot.label))])])
  }), 0) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.movedY && (_vm.theExternalEvent || _vm.deleteSubject) && !_vm.dragActiveDate) ? _c('DCalendarDraggedSubject', {
    attrs: {
      "movedY": _vm.movedY,
      "movedX": _vm.movedX,
      "deleteSubject": _vm.deleteSubject,
      "activeSubject": _vm.theExternalEvent,
      "activeSubjectBCR": _vm.theExternalEventBCR
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isConfirmDeleteModal) ? _c('ModalConfirmation', {
    staticClass: "d-modal--from-top",
    attrs: {
      "show-close": false,
      "appendToBody": false,
      "isShowDontAskAgain": true
    },
    on: {
      "close": _vm.closeIsConfirmDelete,
      "confirm": _vm.onConfirmDeleteEvent
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d63297e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendar.vue
// module id = 2133
// module chunks = 1